import type { StateStorage } from 'zustand/middleware'

/** localStorage that never throws (private windows, blocked site data); the app must still boot as a guest. */
export const safeStorage: StateStorage = {
  getItem: (name) => {
    try {
      return window.localStorage.getItem(name)
    } catch {
      return null
    }
  },
  setItem: (name, value) => {
    try {
      window.localStorage.setItem(name, value)
    } catch {
      // Storage unavailable: the session lasts for this page load only.
    }
  },
  removeItem: (name) => {
    try {
      window.localStorage.removeItem(name)
    } catch {
      // Nothing to remove.
    }
  },
}
